<template>
  <div class="container-fluid">
    <d-row class="p-2">
      <d-col md="8">
        <form v-if="pagination.customerId" class="main-sidebar__search w-100 d-flex">
          <div class="input-group input-group-seamless">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i class="fas fa-search"></i>
              </div>
            </div>
            <d-form-input class="navbar-search" type="text" placeholder="Procurar por algo..." aria-label="Search"
              v-model="pagination.search" @input="search"></d-form-input>
          </div>
        </form>
      </d-col>
      <d-col md="4">
        <div class="d-flex justify-content-end">
          <d-button
            v-if="!isCustomer && !isSelectionMode && fileList.length"
            type="button"
            class="btn btn-secondary text-white mr-2"
            @click.prevent="onOpenModal(MODAL_TYPE)">
            <i class="fas fa-envelope mr-1"></i>Notificar por e-mail
          </d-button>
          <d-button
            v-if="isSelectionMode && selectedFiles.length > 0"
            type="button"
            class="btn btn-primary text-white mr-2"
            @click="downloadFilesZip">
            <i class="fas fa-download mr-1"></i>Baixar todos ({{ selectedFiles.length }})
          </d-button>
          <d-button
            v-if="pagination.customerId"
            type="button"
            :class="isSelectionMode ? 'btn btn-secondary' : 'btn btn-primary'"
            class="text-white mr-2"
            @click="toggleSelectionMode">
            {{ isSelectionMode ? 'Cancelar' : 'Selecionar' }}
          </d-button>
          <d-button v-if="!isCustomer && !isSelectionMode" type="button" class="btn btn-success text-white" @click="uploadFile">Anexar arquivos</d-button>
        </div>
      </d-col>
    </d-row>
    <d-row class="row-table">
      <d-col class="col-table">
        <table class="table mb-0 table-striped">
          <thead class="bg-light">
            <tr>
              <th v-if="isSelectionMode" scope="col" class="td-1 border-0">
                <d-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :indeterminate="isIndeterminate"
                  class="m-0">
                </d-form-checkbox>
              </th>
              <th scope="col" class="td-1 border-0">ID</th>
              <th scope="col" class="text-left border-0">Nome</th>
              <th scope="col" class="td-2 border-0">Opções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in fileList" :key="index" class="">
              <td v-if="isSelectionMode" class="align-middle">
                <d-form-checkbox
                  v-model="selectedFiles"
                  :value="file.id"
                  class="m-0">
                </d-form-checkbox>
              </td>
              <td class="align-middle">{{ file.id }}</td>
              <td class="text-left align-middle">
                <i :class="[getFileIcon(file.file.type), 'icon']"></i>
                <span>{{ file.name }}</span>
              </td>
              <td class="align-middle">
                <d-button-group class="buttons">
                  <d-button size="sm" class="btn-danger" @click.prevent="deleteFile(file)" v-if="!isCustomer">
                    <i class="fas fa-trash" style="margin-right: 5px"></i><span class="d-none d-lg-inline">Deletar</span>
                  </d-button>
                  <d-link v-if="pagination.customerId && !isSelectionMode" size="sm" class="btn btn-success" :href="file.file.download_url" target="_blank">
                    <i class="fas fa-download" style="margin-right: 5px"></i><span class="d-none d-lg-inline">Download</span>
                  </d-link>
                </d-button-group>
              </td>
            </tr>
            <tr v-if="fileList.length === 0" class="drag-row align-items-center">
              <td :colspan="isSelectionMode ? 4 : 3" class="no-content align-middle">Ainda não tem nenhum arquivo atribuido.</td>
            </tr>
          </tbody>
        </table>
      </d-col>
    </d-row>
    <upload-customer-file ref="upload-file" :customerId="pagination.customerId" />
    <send-email-modal/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { downloadBlobFile } from '_utils/require';
import CustomerService from '_services/rest/modules/customer';
import { _SAVE_FILE_SUCCESS_, MODAL_TYPE } from '../CustomerModel';
import UploadCustomerFile from './UploadCustomerFile.vue';
import SendEmailModal from '../modal/SendEmailModal.vue';

export default {
  name: 'customer-files',
  components: {
    UploadCustomerFile,
    SendEmailModal,
  },
  props: {
    onOpenModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      MODAL_TYPE,
      pagination: {
        search: '',
        customerId: parseInt(this.$route.params.customerId, Number),
      },
      isSelectionMode: false,
      selectedFiles: [],
      selectAll: false,
    };
  },
  computed: {
    fileList() {
      const { fileList } = this.$store.state.customer;
      if (fileList && fileList.length > 0) {
        return fileList;
      }
      return [];
    },
    tempFiles() {
      const { tempFiles } = this.$store.state.customer;
      if (tempFiles && tempFiles.length > 0) {
        return tempFiles;
      }
      return [];
    },
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
    isIndeterminate() {
      return this.selectedFiles.length > 0 && this.selectedFiles.length < this.fileList.length;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getFiles',
      'setTempFiles',
      'deleteTempFile',
    ]),
    search() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.loadFileList();
      }, 500);
    },
    loadFileList() {
      this.getFiles(this.pagination);
    },
    uploadFile() {
      this.$refs['upload-file'].resetSelectedFiles();
      this.setToggle({ type: 'upload_file_modal', bool: true });
    },
    toggleSelectionMode() {
      this.isSelectionMode = !this.isSelectionMode;
      if (!this.isSelectionMode) {
        this.selectedFiles = [];
        this.selectAll = false;
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedFiles = [];
      } else {
        this.selectedFiles = this.fileList.map(file => file.id);
      }
    },
    downloadFilesZip() {
      if (this.selectedFiles.length === 0) {
        this.activeAlert({ message: 'Nenhum arquivo selecionado', theme: 'warning' });
        return;
      }

      CustomerService.downloadMultipleFiles(this.pagination.customerId, this.selectedFiles)
        .then(response => {
          const date = new Date().toLocaleDateString().replace(/\//g, '-');
          downloadBlobFile(response, `arquivos_${date}.zip`, 'application/zip');
          this.activeAlert({ message: `${this.selectedFiles.length} arquivo(s) baixado(s) com sucesso`, theme: 'success' });
          this.toggleSelectionMode();
        })
        .catch(err => {
          this.activeAlert({ message: `Erro ao baixar arquivos: ${err.message || err}`, theme: 'danger' });
        });
    },
    deleteFile(selectedFile) {
      if (!this.pagination.customerId) {
        const index = this.tempFiles.findIndex(file => file.id === selectedFile.id);
        this.deleteTempFile(index);
        this.setTempFiles(this.tempFiles);
      } else {
        const fileId = selectedFile.file_id;
        const file = {
          customerId: this.pagination.customerId,
          fileId,
        };
        CustomerService.deleteFile(file)
          .then(() => {
            this.activeAlert({ message: 'Arquivo deletado com sucesso', theme: 'success' });
            this.loadFileList();
          })
          .catch(err => {
            this.activeAlert({ message: `Erro ao deletar o arquivo com id ${fileId}: ${err}`, theme: 'danger' });
          });
      }
    },
    getFileIcon(fileType) {
      switch (fileType) {
        case 'application/pdf':
          return 'fas fa-file-pdf';
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'fas fa-file-word';
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return 'fas fa-file-powerpoint';
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return 'fas fa-file-excel';
        case 'image/jpeg':
        case 'image/png':
          return 'fas fa-file-image';
        case 'text/plain':
          return 'fas fa-file-alt';
        case 'application/zip':
        case 'application/x-rar':
        case 'application/x-rar-compressed':
          return 'fas fa-file-archive';
        default:
          return 'fas fa-file';
      }
    },
  },
  mounted() {
    Events.$on(_SAVE_FILE_SUCCESS_, this.loadFileList);
    this.loadFileList();
  },
  beforeDestroy() {
    Events.$off(_SAVE_FILE_SUCCESS_);
  },
};
</script>

<style lang="scss" scoped>
  .td-1 {
    width: 5%;
  }
  .td-2 {
    width: 15%;
  }
  .icon {
    color: #fb7906;
    font-size: 1.6em;
    margin-right: 0.5em;
    vertical-align: middle;
  }
  .align-middle {
    vertical-align: middle;
  }
</style>
